module.exports = __webpack_public_path__ + "img/tab33.343b4fa7.png";